import React from 'react';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { bibShape } from '@bibliocommons/bc-prop-types';
import { selectSubjectsAndGenres, selectCatalogBib } from 'app/selectors/catalogBibs/CatalogBibSelector';
import { selectBibEntities } from 'app/selectors/EntitiesSelector';
import SubjectAndGenre from './SubjectAndGenre';

export class SubjectAndGenreContainer extends React.PureComponent {
  render() {
    const { subjectsGenres } = this.props;
    return subjectsGenres && <SubjectAndGenre {...this.props} />;
  }
}

SubjectAndGenreContainer.propTypes = {
  subjectsGenres: ImmutablePropTypes.listOf(ImmutablePropTypes.map),
  bib: bibShape.isRequired
};

const mapStateToProps = state => {
  const catalogBib = selectCatalogBib(state);
  const metadataId = catalogBib.get('id');

  return {
    subjectsGenres: selectSubjectsAndGenres(state),
    bib: selectBibEntities(state).get(metadataId)
  };
};

export default connect(mapStateToProps)(SubjectAndGenreContainer);
